import { LockClosedIcon } from "@heroicons/react/20/solid";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const LoadingSpinner = () => (
  // Centralized spinner to be reused
  <div className="flex items-center">
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span>Lädt...</span>
  </div>
);

export default function Register() {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cName, setCName] = useState("");
  const [anrede, setAnrede] = useState("Herr");
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [passwdMsg, setPasswdMsg] = useState("Bitte Passwort erneut eingeben");
  const [btn, setBtn] = useState(false);
  const [consent, setConsent] = useState(false);
  const [ustid, setUstid] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [plz, setPlz] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const checkPassword = (e) => {
    if (password !== e) {
      setBtn(false);
      setPasswdMsg("Passwörter stimmen nicht überein");
    } else {
      setBtn(true);
      setPasswdMsg("Das sieht gut aus");
    }
  };

  const Register = async (e) => {
    e.preventDefault();
    if (
      !(
        name &&
        lastName &&
        cName &&
        anrede &&
        email &&
        password &&
        ustid &&
        telefon &&
        street &&
        city &&
        plz &&
        consent
      )
    )
      return setMsg("Bitte alle Felder ausfüllen.");
    setIsLoading(true);
    await axios
      .post(`https://dealersonly.parts/beta/api/register`, {
        anrede: anrede,
        name: name,
        lastName: lastName,
        cname: cName,
        email: email,
        password: password,
        confPassword: confPassword,
        consent: consent,
        ustid: ustid,
        telefon: telefon,
        street: street,
        city: city,
        plz: plz,
      })
      .then(() => {
        setIsLoading(false);
        setMsg("Erfolgreich! Schauen Sie in Ihre Mails.");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      })
      .catch((error) => {
        console.log(error.response.data);
        setIsLoading(false);
        if (error.response.data) {
          setMsg(error.response.data);
          setTimeout(() => {
            setMsg("");
          }, 1000);
        }
      });
  };

  const html = document.getElementsByTagName("html")[0];
  useEffect(() => {
    html.classList.remove("bg-gray-100");
    html.classList.add("bg-white");
  }, []);

  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img
              className="mx-auto h-12 w-auto"
              src="https://dealersonly.parts/beta/app/files/abujo.jpg"
              alt="D.O.P.E by Abujo Trading"
            />
            <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
              Bei D.O.P.E Registrieren
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Bereits registriert?{" "}
              <Link
                to={"/login"}
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                Jetzt anmelden
              </Link>
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={Register}>
            <p className="has-text-centered">{msg}</p>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="col-span-3 sm:col-span-2">
              <label
                htmlFor="company-name"
                className="block text-sm font-medium text-gray-700"
              >
                Firmenname
              </label>
              <div className="mt-1 flex rounded-md shadow-sm">
                <input
                  type="text"
                  name="company-name"
                  id="company-name"
                  required
                  className="block w-full flex-1 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="MyBusiness GmbH"
                  value={cName}
                  onChange={(e) => setCName(e.target.value)}
                />
              </div>
            </div>
            <div className="col-span-3 sm:col-span-2">
              <label
                htmlFor="ustid"
                className="block text-sm font-medium text-gray-700"
              >
                Umsatzsteuer-ID.
              </label>
              <div className="mt-1 flex rounded-md shadow-sm">
                <input
                  type="text"
                  name="ustid"
                  id="ustid"
                  required
                  className="block w-full flex-1 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="DE..."
                  value={ustid}
                  onChange={(e) => setUstid(e.target.value)}
                />
              </div>
            </div>

            <div className="col-span-3 sm:col-span-2">
              <label
                htmlFor="telefon"
                className="block text-sm font-medium text-gray-700"
              >
                Telefonnummer
              </label>
              <div className="mt-1 flex rounded-md shadow-sm">
                <input
                  type="text"
                  name="telefon"
                  id="telefon"
                  required
                  className="block w-full flex-1 rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                />
              </div>
            </div>
            <div className="col-span-6 sm:col-span-3">
              <label
                htmlFor="country"
                className="block text-sm font-medium text-gray-700"
              >
                Anrede
              </label>
              <div className="mt-1">
                <select
                  id="anrede"
                  name="anrede"
                  autoComplete="country-name"
                  defaultValue={"Herr"}
                  onChange={(e) => setAnrede(e.target.value)}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                >
                  <option selected value="Herr">
                    Herr
                  </option>
                  <option value="Frau">Frau</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6 sm:col-span-3">
                <label htmlFor="first-name" className="sr-only">
                  Vorname
                </label>
                <input
                  type="text"
                  name="first-name"
                  id="first-name"
                  autoComplete="given-name"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Vorname"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="col-span-6 sm:col-span-3">
                <label htmlFor="last-name" className="sr-only">
                  Nachname
                </label>
                <input
                  type="text"
                  name="last-name"
                  id="last-name"
                  autoComplete="family-name"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Nachname"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="col-span-12 sm:col-span-6">
                <label
                  htmlFor="street"
                  className="block text-sm font-medium text-gray-700"
                >
                  Anschrift
                </label>

                <input
                  type="text"
                  name="street"
                  id="street"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Straße und Hausnummer"
                  value={street}
                  onChange={(e) => setStreet(e.target.value)}
                />
              </div>
              <div className="col-span-6 sm:col-span-3">
                <label htmlFor="city" className="sr-only">
                  Stadt
                </label>
                <input
                  type="text"
                  name="city"
                  id="city"
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="Stadt"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </div>
              <div className="col-span-6 sm:col-span-3">
                <label htmlFor="plz" className="sr-only">
                  PLZ
                </label>
                <input
                  type="text"
                  name="plz"
                  id="plz"
                  required
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="PLZ"
                  value={plz}
                  onChange={(e) => setPlz(e.target.value)}
                />
              </div>
            </div>

            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label
                  htmlFor="email-address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Logindetails
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="relative mt-1 block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 mb-3 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Passwort
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Passwort"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Passwort bestätigen
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Passwort bestätigen"
                  value={confPassword}
                  onChange={(e) => {
                    setConfPassword(e.target.value);
                    checkPassword(e.target.value);
                  }}
                />
              </div>
            </div>
            <p className="mt-2 text-sm text-gray-500">{passwdMsg}</p>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 block text-sm text-gray-900"
                >
                  Ich habe die <Link to="/agb">AGB</Link> gelesen und möchte
                  einen Account erstellen.
                </label>
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={!btn}
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:bg-indigo-300"
              >
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <LockClosedIcon
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    aria-hidden="true"
                  />
                </span>
                {msg ? msg : isLoading ? <LoadingSpinner /> : "Registrieren"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
